import { render, staticRenderFns } from "./CircleChart.vue?vue&type=template&id=a354f452"
import script from "./CircleChart.vue?vue&type=script&lang=js"
export * from "./CircleChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports